import { ButtonType, ButtonWidget, TextLinkWidget } from '@tableau/widgets';
import { Messages } from '../../codegen/Localize';
import { getSessionManagementServiceInstance } from '../../sessionManagement/SessionManagementService';
import { StartPageService } from '../../settings/services/StartPageService';
import { IServerUserInfo } from '../../ts/models/IServerUserInfo';
import showResetStartPageDialog from '../services/ResetStartPage';
import { UserSettingsStyle } from '../styles/UserSettingsStyle';
import React = require('react');

export type StartPageSettingProps = {
  startPage: string;
  isViewerSelf: boolean;
  isViewerAdmin: boolean;
  sessionSiteUrlName: string;
  serverUser: IServerUserInfo;
}


export function StartPageSetting(props: StartPageSettingProps): JSX.Element {
  const sanitizedStartPage = getSanitizedStartPage(props.startPage);
  const startPageHref = StartPageService.getStartPageForSite(sanitizedStartPage, props.sessionSiteUrlName);
  return (
    <table>
      <tbody className={UserSettingsStyle.tbodyNew} >
        <tr data-tb-test-id="start-page-setting">
          <td className={UserSettingsStyle.labelTextNew}>
            {Messages.settings_startPage_title()}
            </td>
            <td className={UserSettingsStyle.detailsValue}>
              {
                props.isViewerSelf && getHint(props.isViewerAdmin)
              }
            </td>
          </tr>
        <tr data-tb-test-id="start-page-description">
        <td className={UserSettingsStyle.labelTextNew}></td>
            <td className={UserSettingsStyle.detailsValue}>
            <span>{Messages.settings_startPage_current_start_page()}</span>
            <span>
            <TextLinkWidget
            href={startPageHref}
            testId={'start-page-link'}
            children={sanitizedStartPage}
            target='_blank'/>
            {!props.startPage && Messages.reserStartPage_default()}
            </span>
            <span>&nbsp;&nbsp;</span>
            <span>
              <ButtonWidget
              buttonType={ButtonType.Outline}
              testId='reset-to-default-start-page'
              disabled={!startPageHref || !props.startPage}
              onClick={() => showResetStartPageDialog(props.serverUser)}
              children={Messages.resetStartPage_button()}
              />
              </span>
            </td>
          </tr>
        </tbody>
      </table>
  );
}

function getHint(isViewerAdmin: boolean) {
  const message = isViewerAdmin? Messages.startPageHint_admin(): Messages.startPageHint_user();

  return(
    <div data-tb-test-id = "start-page-hint">
      {message}
    </div>
  );
}

function getSanitizedStartPage(startPage: string) {
  if (!startPage) {
    return getSessionManagementServiceInstance().getStartPage();
  }
  return startPage;
}